import { TextField } from "@mui/material";
import { useState } from "react";
import DialogSelectTitulos from "./DialogSelectTitulos";
import { IDataListaTitulosReceber } from "../../../types/api/financeiro/pesquisar-titulos-receber";

export default function SelectTitulosReceber({
    value,
    onChange,
    extraParams,
    possuiBtnLimpar = false,
    multiple = false,
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = (() => {
        if (!value) return "";
        if (Array.isArray(value)) {
            return value.map((item) => `${item.id}`).join(", ");
        } else {
            return `${value.id}`;
        }
    })();

    const handleSubmit = (selectedValue: IDataListaTitulosReceber | IDataListaTitulosReceber[] | null) => {
        onChange(selectedValue);
    };

    return (
        <>
            <TextField
                label="Título a receber"
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
            />

            {openModal && (
                <DialogSelectTitulos
                    open={openModal}
                    handleClose={handleClose}
                    onSubmit={handleSubmit}
                    extraParams={extraParams}
                    multiple={multiple}
                    defaultValue={value}
                />
            )}
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: IDataListaTitulosReceber | IDataListaTitulosReceber[] | null;
    extraParams?: TExtraParams;
    possuiBtnLimpar?: boolean;
    multiple?: boolean;
    onChange: (arg: IDataListaTitulosReceber | IDataListaTitulosReceber[] | null) => void;
}

type TExtraParams = {
    [key: string]: any;
}